import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

export const ApiService = {
  init() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL
    if (process.env.VUE_APP_API_TOKEN) {
      Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${process.env.VUE_APP_API_TOKEN}`
    }
    Vue.axios.defaults.headers.common['ClientId'] = `${process.env.VUE_APP_API_CLIENT_ID}`
    Vue.axios.defaults.headers.common['ChannelId'] = `${process.env.VUE_APP_API_CHANNEL_ID}`
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[SP] ApiService ${error}`)
    })
  },

  get(resource, slug = '') {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      throw new Error(`[SP] ApiService ${error}`)
    })
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params)
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params)
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params)
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`[SP] ApiService ${error}`)
    })
  },
}

export const DeviceService = {
  query(type, params) {
    return ApiService.query('devices', params)
  },
  get(slug) {
    return ApiService.get('devices', slug)
  },
  getTopic(device, topic) {
    return ApiService.get(`devices/${device}/topics`, topic)
  },
  getDetectionDevices(params) {
    var instance = axios.create()
    instance.defaults.headers.common = {}
    return instance.get(`https://wm-api.com/detect/me`, params)
  },
}

export const SearchService = {
  post(params) {
    return ApiService.post('search', params)
  },
  getDevicesByGeneric({genericItemId, genericType, query}) {
    return ApiService.post(`search/${genericType}`, { contextItemId: genericItemId, query })
  },
  getGenericContentItem({method, deviceId, cmtReferenceId}) {
    return ApiService.query(`${method}/${deviceId}/${cmtReferenceId}`)
  }
}
